import _implicitStylesheets from "./learnHome.css";
import _implicitScopedStylesheets from "./learnHome.scoped.css?scoped=true";
import _cmsWordpressSlugContent from "cms/wordpressSlugContent";
import _cmsFilter from "cms/filter";
import _cmsContentSection from "cms/contentSection";
import _cmsPagination from "cms/pagination";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div class="axwp-empty-state__container${0}"${2}><div class="axwp-empty-state__img${0}"${2}><img${"a2:src"}${3}></div><span class="axwp-empty-state__title${0}"${2}>${"t4"}</span><p class="axwp-empty-state__subtitle${0}"${2}>${"t6"}</p></div>`;
const $fragment2 = parseFragment`<div class="axwp-error-state__container${0}"${2}><div class="axwp-error-state__image${0}"${2}><img src="./images/search/error.svg"${"a2:alt"}${3}></div><p class="axwp-empty-state__title axwp-error-state__title${0}"${2}>${"t4"}</p><p class="axwp-error-state__description${0}"${2}>${"t6"}</p></div>`;
const stc0 = {
  props: {
    "slug": "learn-landing"
  },
  key: 1
};
const stc1 = {
  classMap: {
    "axwp-learn-home__container": true
  },
  key: 2
};
const stc2 = {
  classMap: {
    "axwp-filters": true
  },
  key: 3
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, c: api_custom_element, k: api_key, i: api_iterator, h: api_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, f: api_flatten} = $api;
  const {_m0, _m1} = $ctx;
  return [api_element("div", {
    key: 0,
    on: {
      "learnfilter": _m0 || ($ctx._m0 = api_bind($cmp.filterUpdated))
    }
  }, [api_custom_element("cms-wordpress-slug-content", _cmsWordpressSlugContent, stc0), api_element("div", stc1, api_flatten([!$cmp.displayErrorState ? api_element("div", stc2, api_iterator($cmp.filters, function (filter) {
    return api_custom_element("cms-filter", _cmsFilter, {
      props: {
        "options": filter.options,
        "label": filter.label,
        "filterType": filter.type
      },
      key: api_key(4, filter.type)
    });
  })) : null, api_iterator($cmp.visiblePostSections, function (section) {
    return api_custom_element("cms-content-section", _cmsContentSection, {
      props: {
        "section": section,
        "filtered": $cmp.filterActive
      },
      key: api_key(5, section.slug)
    });
  }), $cmp.displayEmptyState ? api_static_fragment($fragment1, 7, [api_static_part(2, {
    attrs: {
      "src": $cmp.errorEmptyStateImageUrl
    }
  }, null), api_static_part(4, null, api_dynamic_text($cmp.labels.homeEmptyTitle)), api_static_part(6, null, api_dynamic_text($cmp.labels.homeEmptyText))]) : null, $cmp.displayErrorState ? api_static_fragment($fragment2, 9, [api_static_part(2, {
    attrs: {
      "alt": $cmp.altText
    }
  }, null), api_static_part(4, null, api_dynamic_text($cmp.labels.homeErrorTitle)), api_static_part(6, null, api_dynamic_text($cmp.labels.homeErrorText))]) : null, $cmp.showPagination ? api_custom_element("cms-pagination", _cmsPagination, {
    props: {
      "pages": $cmp.pageList
    },
    key: 10,
    on: {
      "learnpagechange": _m1 || ($ctx._m1 = api_bind($cmp.pageClicked))
    }
  }) : null]))])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-2n2lcmasbe4";
tmpl.legacyStylesheetToken = "undefined-_learnHome";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
